import React from 'react';
import './LegalPage.css';

const PrivacyPage: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: July 28, 2026</p>

        <section>
          <h2>1. What I Collect</h2>
          <p>When you place an order or sign up for the mailing list, I collect:</p>
          <ul>
            <li>Name and email address</li>
            <li>Shipping address</li>
            <li>Payment information (processed securely by Stripe — I never see or store your card number)</li>
          </ul>
        </section>

        <section>
          <h2>2. How I Use Your Information</h2>
          <ul>
            <li>To fulfill and ship your orders</li>
            <li>To send order confirmations and shipping updates</li>
            <li>To send newsletter updates (only if you opted in)</li>
          </ul>
          <p>I do not sell, rent, or share your personal information with third parties for marketing purposes.</p>
        </section>

        <section>
          <h2>3. Third-Party Services</h2>
          <p>I use the following services to operate this store:</p>
          <ul>
            <li><strong>Stripe</strong> — payment processing</li>
            <li><strong>AWS</strong> — hosting and data storage</li>
          </ul>
          <p>These services have their own privacy policies governing how they handle your data.</p>
        </section>

        <section>
          <h2>4. Cookies</h2>
          <p>
            This site uses minimal cookies for essential functionality (e.g., keeping your cart). I do not use
            tracking cookies or third-party analytics.
          </p>
        </section>

        <section>
          <h2>5. Your Rights</h2>
          <p>
            You can request to see, update, or delete your personal data at any time.
            Contact me at <a href="mailto:hello@micahlynise.com">hello@micahlynise.com</a>.
          </p>
        </section>

        <section>
          <h2>6. Contact</h2>
          <p>
            Questions about this policy? Please contact me at <a href="mailto:hello@micahlynise.com">hello@micahlynise.com</a>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPage;
